<div class="Flex--row Statistikmonitor">



    <FloatingWindow @closeButtonClick="showGlossary=false" v-if="showGlossary" title="Glossar" :dockButton="false" :show.sync="showGlossary" :fullscreenWindow="true">
        <iframe :src="glossaryUrl" style="width:100%;height:100%" />
    </FloatingWindow>



    <div class="Flex--col Card hide-on-print" style="padding:20px;min-width:320px;max-width:320px">
        <h3>Indikator:</h3>

        <div style="display:flex;flex-direction: row;align-items: center;">

            <select v-model="indicator" class="Input">
                <option v-if="indicator==null" :value="null">Bitte wählen</option>
                <option v-for="idc in getStrukturIndicators()" :value="idc">{{idc.name}}</option>
            </select>

        </div>


        <template v-if="indicator != null">
            <p>
                <Superbutton label="Glossar" icon="tivigi/img/question.svg" @click="openGlossary(getGlossaryLink(indicator.code))" alt="Glossar zum Themenbereich öffnen" title="Glossar zum Themenbereich öffnen" />
            </p>

            <p>
                <Superbutton label="Drucken" icon="/img/print.svg" :set="true" @click="print()" />
            </p>
            <p style="margin-top:0px;font-size:0.9em">Empfohlen wird der Druck im Querformat.</p>


        </template>
    </div>


    <div class="Flex--col Card" style="padding:20px">
        <h1 class="hide-on-screen">STATISTIKMONITOR Rhein-Neckar</h1>
        <h1>Steckbrief zur strukturellen Situation in den Kreisen der MRN</h1>

        <template v-if="indicator != null">
            <h2>
                {{indicator.name}} - {{latestYear}}
            </h2>

            <table class="Table">
                <tr>
                    <th>Raumeinheit</th>
                    <!--
                    <th style="text-align:center;width:80%">
                        - <span style="display:inline-block;width:100px"></span> +
                    </th>
                    -->
                    <th style="width:80%">
                        <!--
                        <BarDisplay style="width:100%;" :showRange="true" :max="max" :min="min" />
                        -->
                    </th>
                    <th class="numeric">
                        Wert
                    </th>
                </tr>


                <tr v-for="su in spatialUnitsDynamik" :class="getCssClass(su)">

                    <td style="white-space: nowrap;">{{su.properties.name}}</td>

                    <td>
                        <BarDisplay style="width:100%;" :value="getValue(su, indicator.code, latestYear)" :max="max" :min="min" />
                        <!--
                        <BarDisplay style="width:100%;border-left:1px solid #ccc;border-right:1px solid #ccc" :value="getValue(su, indicator.code, latestYear)" :max="absMax" :min="-absMax" />
                        -->
                    </td>

                    <td class="numeric">
                        {{getValue(su, indicator.code, latestYear) | formatNumber(indicator.decimal_places)}}
                    </td>

                </tr>
            </table>


        </template>
        <template v-else>
          
            <p class="Statistikmonitor__Hint">Bitte wählen Sie einen Indikator.</p>
        </template>
    </div>
</div>